import {
  Box,
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Select,
  Text,
} from '@chakra-ui/react'

import { useLocalRecording } from '@/react-query/local-recording'
import { useUserSettings } from '@/react-query/user-settings'
import { MicrophoneIcon } from '@/views/assets/MicrophoneIcon'
import { TabIcon } from '@/views/assets/TabIcon'

import { LiveTranscriptionProvider } from '../../../../context/AudioRecorderContext/types'

import { ExistingRecording } from './ExistingRecording'

const PROVIDER_OPTIONS: {
  value: LiveTranscriptionProvider
  label: string
}[] = [
  { value: 'deepgram', label: 'Deepgram' },
  { value: 'openai', label: 'OpenAI' },
  { value: 'assemblyai', label: 'AssemblyAI' },
]

interface RecordingMenuProps {
  onMicClick: () => void
  onTabClick: () => void
  selectedProvider: LiveTranscriptionProvider
  onProviderChange: (provider: LiveTranscriptionProvider) => void
}

export const RecordingMenu = ({
  onMicClick,
  onTabClick,
  selectedProvider,
  onProviderChange,
}: RecordingMenuProps) => {
  const { data: recording } = useLocalRecording()
  const { data: userSettings } = useUserSettings()
  const liveTranscriptionEnabled =
    userSettings?.enableLiveTranscription ?? false

  if (recording) {
    return <ExistingRecording />
  }

  return (
    <Flex gap={3} alignItems="center">
      {liveTranscriptionEnabled && (
        <Flex alignItems="center" gap={2}>
          <Text fontSize="sm" whiteSpace="nowrap">
            Transcription:
          </Text>
          <Select
            size="sm"
            width="130px"
            value={selectedProvider}
            onChange={(e) =>
              onProviderChange(e.target.value as LiveTranscriptionProvider)
            }
            borderRadius="lg"
          >
            {PROVIDER_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
        </Flex>
      )}
      <Menu>
        <MenuButton
          as={Button}
          variant={'brand-solid-white'}
          leftIcon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
            >
              <circle cx="5" cy="5" r="5" fill="black" />
            </svg>
          }
        >
          Record Live
        </MenuButton>

        <MenuList>
          <MenuItem
            onClick={onMicClick}
            display={'flex'}
            alignItems={'center'}
            pr={6}
            px={5}
            className={'!pt-4'}
          >
            <MicrophoneIcon width={'20px'} height={'21px'} />
            <Box ml={3}>Record via microphone</Box>
          </MenuItem>
          <MenuItem
            onClick={onTabClick}
            display={'flex'}
            alignItems={'center'}
            pr={6}
            px={5}
            className={'!pb-4'}
          >
            <TabIcon width={'20px'} height={'19px'} />
            <Box ml={3}>Record a browser tab</Box>
          </MenuItem>
        </MenuList>
      </Menu>
    </Flex>
  )
}
